// @flow
import React, { Component } from 'react'
import type { OptionType } from '../types'
import { SelectItem, TextInputItem, ButtonItem } from '../controls/MassOperationsForm'

type Props = {|
  paramToChange: string,
  changeType: string,
  valueChangeType: string,
  value: string,
  isLoading: boolean,
  paramToChangeErrors: Array<string>,
  changeTypeErrors: Array<string>,
  valueChangeTypeErrors: Array<string>,
  valueErrors: Array<string>,
  onChange: Function,
  onApply: Function
|}

const t = {
  absolute: 'Абсолютное значение',
  apply: 'Применить',
  budget: 'Бюджет',
  change_type_label: 'Тип изменения',
  decrease: 'Понизить',
  increase: 'Повысить',
  param_to_change_label: 'Параметр для изменения',
  percent: 'Процент',
  price: 'Ставка',
  set: 'Задать',
  value_change_type_label: 'Изменить на абсолютное значение или на процент',
  value_label: 'Значение'
}

export default class PriceBudgetModal extends Component<Props> {
  render() {
    const {
      paramToChange,
      changeType,
      valueChangeType,
      value,
      paramToChangeErrors,
      changeTypeErrors,
      valueChangeTypeErrors,
      valueErrors,
      isLoading
    } = this.props
    return (
      <div>
        <SelectItem
          inputGroupClassName="t-ParamToChangeSelect"
          label={t.param_to_change_label}
          errors={paramToChangeErrors}
          value={paramToChange}
          options={this.paramToChangeOptions()}
          disabled={isLoading}
          onChange={(paramToChange) =>
            this.props.onChange({ paramToChange, paramToChangeErrors: [] })
          }
        />
        <SelectItem
          inputGroupClassName="t-ChangeTypeSelect"
          label={t.change_type_label}
          errors={changeTypeErrors}
          value={changeType}
          options={this.changeTypeOptions()}
          disabled={isLoading}
          onChange={(changeType) => this.props.onChange({ changeType, changeTypeErrors: [] })}
        />
        <SelectItem
          inputGroupClassName="t-ValueChangeTypeSelect"
          label={t.value_change_type_label}
          errors={valueChangeTypeErrors}
          value={valueChangeType}
          options={this.valueChangeTypeOptions()}
          disabled={isLoading}
          onChange={(valueChangeType) =>
            this.props.onChange({ valueChangeType, valueChangeTypeErrors: [] })
          }
        />
        <TextInputItem
          inputGroupClassName="t-ValueInput"
          label={t.value_label}
          errors={valueErrors}
          className="form-control input-item"
          value={value}
          disabled={isLoading}
          onChange={(e) =>
            this.props.onChange({ value: this.parseString(e.target.value), valueErrors: [] })
          }
        />
        <ButtonItem
          buttonText={t.apply}
          onClick={() => this.props.onApply()}
          disabled={isLoading}
        />
      </div>
    )
  }

  paramToChangeOptions(): Array<OptionType> {
    return [
      { id: 'price', name: t.price },
      { id: 'budget', name: t.budget }
    ]
  }

  changeTypeOptions(): Array<OptionType> {
    return [
      { id: 'set', name: t.set },
      { id: 'increase', name: t.increase },
      { id: 'decrease', name: t.decrease }
    ]
  }

  valueChangeTypeOptions(): Array<OptionType> {
    return [
      { id: 'absolute', name: t.absolute },
      { id: 'percent', name: t.percent }
    ]
  }

  parseString(s: string) {
    return s.replace(/[^.0-9]/, '')
  }
}
